import { PropertySetModule } from "../admin/property-set/modal"
import { ApiAddress } from "../apis"
import request from "../request"
import { CaseModal } from "./cases.service"
import { IUnitData } from "./modal"

export interface SimulationModal {
  id: number
  fsfile: any
  opcase: CaseModal
}

export interface EquipmentAttribute {
  attribute: string
  unitId: string
  value?: number
  displayValue?: string
}

export interface SimSeq {
  index: number
  name: string
  intialGuess: EquipmentAttribute[]
  target: EquipmentAttribute[]
}

export interface ManualVal {
  type: number
  val: number
}

export function getProjectSimulations(params): Promise<SimulationModal[]> {
  return request.get(ApiAddress.FS_SIMULATIONS, {params, headers: {'SIM-TOKEN': '1111'}})
}

export function initSimulation(params): Promise<SimulationModal> {
  return request.post(ApiAddress.INIT_SIMULATION, {}, {params, headers: {'SIM-TOKEN': '1111'}})
}

export function setPropertySetsToSim(body, params) {
  return request.put(ApiAddress.SIM_PROPERTY_SETS, body, {params, headers: {'SIM-TOKEN': '1111'}})
}

export function runSimTopology(data, params) {
  return request.put(ApiAddress.SIM_TOPOLOGY, data, {params, headers: {'SIM-TOKEN': '1111'}})
}

export function getSimManualInputs(params): Promise<EquipmentAttribute[]> {
  return request.get(ApiAddress.SIM_MANUAL_INPUTS, {params, headers: {'SIM-TOKEN': '1111'}})
}

export function getSimPropertyType(params): Promise<PropertySetModule.Modal[]> {
  return request.get(ApiAddress.SIM_PROPERTY_SETS, {params, headers: {'SIM-TOKEN': '1111'}})
}

export function getSimSeqs(params): Promise<SimSeq[]> {
  return request.get(ApiAddress.SIM_SEQS, {params, headers: {'SIM-TOKEN': '1111'}})
}

export function createSimSeq(body, params) {
  return request.post(ApiAddress.SIM_SEQS, body, {params, headers: {'SIM-TOKEN': '1111'}})
}

export function getSimUnitData(params): Promise<IUnitData> {
  if(!params.sId) return Promise.reject();
  return request.get(ApiAddress.SIM_UNIT_DATA, {params, headers: {'SIM-TOKEN': '1111'}})
}

export function deleteSimSeq(params) {
  return request.delete(ApiAddress.SIM_SEQ, {params, headers: {'SIM-TOKEN': '1111'}})
}

export function getSimSeq(params): Promise<SimSeq> {
  return request.get(ApiAddress.SIM_SEQ, {params, headers: {'SIM-TOKEN': '1111'}})
}

export function updateSimSeq(body, params): Promise<SimSeq> {
  return request.put(ApiAddress.SIM_SEQ, body, {params, headers: {'SIM-TOKEN': '1111'}})
}

export function runSimSeq(params) {
  return request.put(ApiAddress.SIM_SEQ_RUN, {}, {params, headers: {'SIM-TOKEN': '1111'}})
}

export function rerunSimSeq(params) {
  return request.put(ApiAddress.SIM_SEQ_RERUN, {}, {params, headers: {'SIM-TOKEN': '1111'}})
}

export function updateUnitTTPS(body, params) {
  return request.put(ApiAddress.UPDATE_UNIT_TTPS, body, {params, headers: {'SIM-TOKEN': '1111'}})
}

export function saveSimulation(params) {
  return request.put(ApiAddress.SAVE_SIM, {}, {params, headers: {'SIM-TOKEN': '1111'}})
}

export function changeManualInputs(body, params) {
  return request.put(ApiAddress.SIM_MANUAL_INPUTS, body, {params, headers: {'SIM-TOKEN': '1111'}})
}

export function addManualInput(body, params) {
  return request.put(ApiAddress.ADD_MANUAL_INPUT, body, {params, headers: {'SIM-TOKEN': '1111'}})
}

export function deleteManualInput(body, params) {
  return request.post(ApiAddress.REMOVE_MANUAL_INPUT, body, {params, headers: {'SIM-TOKEN': '1111'}})
}

export function saveManualInput(body, params) {
  return request.put(ApiAddress.SAVE_MANUAL_INPUT, body, {params, headers: {'SIM-TOKEN': '1111'}})
}

export function loadSimlation(sId: number) {
  return request.put(ApiAddress.LOAD_SIM, {}, {params: {sId}, headers: {'SIM-TOKEN': '1111'}})
}

export function unloadSimlation(sId: number) {
  return request.put(ApiAddress.UNLOAD_SIM, {}, {params: {sId}, headers: {'SIM-TOKEN': '1111'}})
}

export function changeCondition(body, params) {
  return request.put(ApiAddress.CONDITION_ACTION, body, {params, headers: {'SIM-TOKEN': '1111'}})
}

export function removeCondition(body, params) {
  return request.post(ApiAddress.CONDITION_ACTION_REMOVE, body, {params, headers: {'SIM-TOKEN': '1111'}})
}

export function updateTopology(body, params) {
  return request.put(ApiAddress.UPDATE_TOPOLOPY, body, {params, headers: {'SIM-TOKEN': '1111'}})
}

export function checkTopology(body, params) {
  return request.put(ApiAddress.CHECK_TOPOLOPY, body, {params, headers: {'SIM-TOKEN': '1111'}})
}

export function getSetOps(params) {
  return request.get(ApiAddress.SET_OPS, {params, headers: {'SIM-TOKEN': '1111'}})
}

export function putSimRXSET(body, params) {
  return request.put(ApiAddress.SIM_RXSET, body, {params, headers: {'SIM-TOKEN': '1111'}})
}

export function updateBalancePoint(body, params) {
  return request.put(ApiAddress.UNIT_BALANCE_POINT, body, {params, headers: {'SIM-TOKEN': '1111'}})
}

